import React from 'react'
import { InputAdornment, TextField } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'

type Props = {
  maxHeadCount?: number
  error?: string
  headCount?: number
  unusable?: boolean
  disabled?: boolean
  onChange: (newHeadcount: number) => void
}

const HeadCount: React.FC<Props> = ({
  maxHeadCount = Infinity,
  error,
  headCount,
  disabled,
  onChange,
}) => {
  const minHeadCount = 0

  const handleChange = ({ value }: { value: string }) => {
    const parsed = Number(value)
    if (Number.isNaN(parsed)) {
      onChange(0)
      return
    }

    const next = parsed < minHeadCount ? minHeadCount : parsed
    onChange(next)
  }

  const exceedsMax = Number.isFinite(maxHeadCount) && (headCount ?? 0) > maxHeadCount
  const helperText = error ?? (exceedsMax ? `Maximum head count is ${maxHeadCount}` : '')
  const showError = Boolean(helperText)

  return (
    <TextField
      size="small"
      fullWidth
      type="number"
      disabled={disabled}
      placeholder="0"
      slotProps={{
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <PersonIcon color="primary" />
            </InputAdornment>
          ),
        },
      }}
      error={showError}
      helperText={helperText}
      value={headCount || ''}
      onChange={(e) => handleChange(e.target)}
      data-cy="headcount-input"
      sx={{
        '& .MuiOutlinedInput-root': {
          borderRadius: 4,
        },
      }}
    />
  )
}

export default HeadCount
